function Home() {
  return (
    <div className="container">
      <div className="card">
        <h2>Welcome to Deepthi’s App 🚀</h2>
        <p>This is a multi-page React app using React Router.</p>
      </div>
    </div>
  );
}

export default Home;